module.exports = __webpack_public_path__ + "fonts/montserrat-semibold.c74260cde1a16b48febba358704ac4b6.woff2";